<template>
  <div class="coupon-wrapper">
    <button type="button" class="btn btn-primary btn-small" id="btnHaveCoupon" v-if="!showCouponArea" @click="showCouponArea = true">
      I have a coupon
    </button>
    <div class="col-md-12" v-if="couponMessage && (couponMessage !== 'error')">
      <p><i class="fa fa-check"></i> {{ couponMessage }}</p>
    </div>

    <div class="row" id="valid-coupon" v-if="couponMessage === 'error'">
      <div class="col-md-12">
        <div class="alert alert-danger" role="alert"><span class="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span><span class="sr-only"> Error:</span> Invalid Coupon</div>
      </div>
    </div>

    <div class="row form-group" id="coupon-code" v-show="showCouponArea">
      <div class="col-sm-6 col-md-4 form-group no-marg" v-if="!couponAccepted">
        <label class="control-label">Coupon Code</label>
        <input id="coupon" name="coupon" type="text"
               class="form-control validate coupon" autocomplete="coupon"
               placeholder="coupon"
               v-model="coupon_code"
        >
      </div>

      <div class="col-sm-6 col-md-4 form-group no-marg" v-if="!couponAccepted">
        <button type="button" class="btn btn-primary btn-small"
                id="btnSubmitCoupon"
                @click="submitCoupon()"
                style="margin-top: 34px;margin-bottom: 0px;">
          Submit coupon
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Coupon",
  props: ['currentCoupon'],
  data() {
    return {
      showCouponArea: false,
      couponMessage: null,
      couponAccepted: false,
      coupon_code: null,
    }
  },
  methods: {
    submitCoupon() {
      axios.post('/coupon/verify', {'coupon_code': this.coupon_code})
          .then((res) => {
            if (res.data === 'token not found') {
              this.couponMessage = 'error'
            } else if (res.data) {
              this.couponAccepted = true
              this.couponMessage = "Coupon accepted. " + res.data.message
              this.$emit('couponSubmit', res.data)
            }
          }).catch((error) => {
        console.log(error)
        this.couponMessage = this.coupons['error']
      })
    },
  },
  created() {
   if (this.currentCoupon) {
     this.coupon_code = this.currentCoupon;
     this.showCouponArea = true;
     this.submitCoupon();
   }
  }
}
</script>

<style scoped>

</style>